import * as React from 'react'
import Image from 'next/image'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { styled } from '@mui/material/styles'
import { Box, Stack } from '@mui/material'

import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'

const CtaCard = styled('div')`
    padding: 1.5rem;
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    overflow: hidden;
`

const ImageWrapper = styled(Box)`
    width: 100%;
    max-width: 30rem;
    opacity: 0.7;
    transform: translateY(1.5rem);
`

interface CardCtaImageProps {
    title: string
    description: string
    buttonText: string
    image: string
    onClick?: () => void
}

const CardCtaImage = (props: CardCtaImageProps) => {
    return (
        <CtaCard>
            <Stack direction="row" spacing="1rem" justifyContent="space-between">
                <Stack>
                    <Text variant="h4">{props.title}</Text>
                    <Text mt={1} color="text.secondary">
                        {props.description}
                    </Text>
                    <Box mt={3}>
                        <Button onClick={props.onClick} variant="contained" endIcon={<ChevronRightIcon />}>
                            {props.buttonText}
                        </Button>
                    </Box>
                </Stack>
                <ImageWrapper sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <Image
                        src={props.image}
                        height="50%"
                        width="100%"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="top"
                        alt=""
                    />
                </ImageWrapper>
            </Stack>
            <Box mt={4} sx={{ display: { sm: 'none' } }}>
                <ImageWrapper>
                    <Image
                        src={props.image}
                        height="50%"
                        width="100%"
                        layout="responsive"
                        objectFit="cover"
                        objectPosition="top"
                        alt=""
                    />
                </ImageWrapper>
            </Box>
        </CtaCard>
    )
}

export default CardCtaImage
